module.exports = __webpack_public_path__ + "img/register_04.bda4f868.png";